<template>
  <v-container class="_pagina_account mb-16">

    <v-row class="my-5">
      <v-col sm="12" md="4" class="d-flex justify-center" style="background-color:#6d94cd;">
        <h2 style="color:white" class=" mt-4">Bando a cui partecipare</h2>
      </v-col>
      <v-col sm="12" md="8" class="px-10">
        <v-row data-tour-step-account="2" class="flex-column justify-center mb-6">
          <div class="_semi_bold">Scegli il bando</div>
          <v-select
            class="pt-0"
            item-text="nome"
            item-value="id"
            :items="bandi"
						v-model="bandoId"
						placeholder="Seleziona"
            @change="setBando()"
            :disabled="isLoadingBando"
            :loading="isLoadingBando"
          ></v-select>
        </v-row>
        <v-row data-tour-step-account="3" class="flex-column justify-center">
          <div class="_semi_bold">Dati personali:</div>
          <div class="_semi_bold">seleziona gli account abilitati ad effettuare modifiche</div>
          <v-radio-group class="mt-2" v-model="chiPuoModificareiDatiDelCliccatore">
            <v-radio
              v-for="(permesso, index) in permessiModificheDatiCliccatore"
              :key="index"
              :label="permesso.label"
              :value="permesso.value"
              :color="scdColor"
              @change="setPermessoModificheDati(permesso.value)"
              :disabled="isLoadingPermessiDati"
            ></v-radio>
            <template v-if="isLoadingPermessiDati">
              <v-progress-linear indeterminate height="2" :color="scdColor"></v-progress-linear>
            </template>
            <div v-else style="height:2px"></div>
          </v-radio-group>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="my-5">
      <v-col
	      sm="12"
	      md="4"
	      class="d-flex justify-center"
	      style="background-color:#6d94cd"
      >
        <h2 style="color:white" class=" mt-4">Tempo da battere</h2>
      </v-col>
      <v-col sm="12" md="8" class="px-10">
        <v-row class="mb-6">
          <div data-tour-step-account="4" class="mr-5">
            <div class="_semi_bold mb-2">Tempi di riferimento del bando precedente</div>
	          <v-btn
		          style="color:white; height:40px;"
		          depressed
		          :color="scdColor"
		          @click="visualizzaTempi()"
		          :disabled="isLoadingTempoDaBattere"
		          :loading="isSavingTempoDaBattere"
	          >
		          Visualizza i tempi
	          </v-btn>

            <!--<v-simple-table class="tempi-simple-table" dense fixed-header :height="`${isLoadingTempiRegione ? 'unset' : '300px'}`">-->
            <!--  <template v-slot:default>-->
            <!--    <thead>-->
            <!--      <tr>-->
            <!--        <th class="text-left">Regione</th>-->
            <!--        <th class="text-left">Tempo</th>-->
            <!--      </tr>-->
            <!--    </thead>-->
            <!--    <tbody>-->
						<!--			<tr v-if="isLoadingTempiRegione">-->
						<!--				<td colspan="2">-->
						<!--					<v-progress-linear-->
						<!--						indeterminate-->
						<!--						color="primary"-->
						<!--					></v-progress-linear>-->
						<!--				</td>-->
						<!--			</tr>-->
            <!--      <tr v-else v-for="tpr in tempiPerRegione" :key="tpr.regione">-->
            <!--        <td>{{ tpr.regione }}</td>-->
            <!--        <td>{{ tpr.tempo }}</td>-->
            <!--      </tr>-->
            <!--    </tbody>-->
            <!--  </template>-->
            <!--</v-simple-table>-->
          </div>
          <div>
            <div data-tour-step-account="5">
              <div class="_semi_bold mb-2">Tempo personalizzato</div>
              <v-text-field
	              style="width:220px;"
	              suffix="secondi"
	              outlined
	              flat
	              dense
	              v-model="tempoDaBattere"
	              :disabled="isLoadingTempoDaBattere || isSavingTempoDaBattere"
	              :loading="isLoadingTempoDaBattere"
              >
                <template v-slot:append-outer  class="ma-0">
                  <v-btn
	                  style="color:white; height:40px;"
	                  depressed
	                  :color="scdColor"
	                  @click="setTempoDaBattere()"
	                  :disabled="isLoadingTempoDaBattere"
	                  :loading="isSavingTempoDaBattere"
                  >
	                  Salva
                  </v-btn>
                </template>
              </v-text-field>
            </div>
            <!-- <v-btn style="color:white" rounded depressed :color="scdColor" @click="setTempoDaBattere()" :disabled="isLoadingTempoDaBattere">Salva</v-btn> -->
          </div>
        </v-row>
      </v-col>
    </v-row>
	  
	  <v-row
		  v-if="computedClienteClickdayIt"
		  class="my-5"
	  >
		  <v-col
			  sm="12"
			  md="4"
			  class="d-flex justify-center"
			  style="background-color:#6d94cd"
		  >
			  <h2 style="color:white" class=" mt-4">Gaming</h2>
		  </v-col>
		  <v-col sm="12" md="8" class="px-10">
			  <v-row>
				  <v-col>
					  <div class="_semi_bold mb-2">Percentuale di vittorie per passare la selezione</div>
					  <v-text-field
						  style="width:177px;"
						  suffix="%"
						  outlined
						  flat
						  dense
						  :loading="isLoadingBando"
						  v-model="minimoWinScoreSelezione"
						  :disabled="isLoadingBando || isSavingMinimoWinScoreSelezione"
					  >
						  <template
							  v-slot:append-outer
							  class="ma-0"
						  >
							  <v-btn
								  style="color:white; height:40px;"
								  depressed
								  :color="scdColor"
								  @click="setMinimoWinScoreSelezione()"
								  :disabled="isLoadingBando"
								  :loading="isSavingMinimoWinScoreSelezione"
							  >
								  Salva
							  </v-btn>
						  </template>
					  </v-text-field>
				  </v-col>
				  <v-col>
					  <div class="_semi_bold mb-2">Numero minimo di simulazioni da fare per far avvenire il calcolo del Win Score</div>
					  <v-text-field
						  style="width:300px;"
						  suffix="simulazioni"
						  outlined
						  flat
						  dense
						  :loading="isLoadingBando"
						  v-model="minimoSimulazioniSelezione"
						  :disabled="isLoadingBando || isSavingMinimoSimulazioniSelezione"
					  >
						  <template
							  v-slot:append-outer
							  class="ma-0"
						  >
							  <v-btn
								  style="color:white; height:40px;"
								  depressed
								  :color="scdColor"
								  @click="setMinimoSimulazioniSelezione()"
								  :disabled="isLoadingBando"
								  :loading="isSavingMinimoSimulazioniSelezione"
							  >
								  Salva
							  </v-btn>
						  </template>
					  </v-text-field>
				  </v-col>
			  </v-row>
		  </v-col>
	  </v-row>

    <v-row class="my-5">
      <v-col sm="12" md="4" class="d-flex justify-center" style="background-color:#6d94cd">
        <h2 style="color:white" class=" mt-4">Il tuo pacchetto</h2>
      </v-col>
      <v-col data-tour-step-account="6" sm="12" md="6" class="px-10">
        <v-row>
          <v-text-field value="Simulazioni rimanenti" :suffix="simulazioniRimanenti" flat dense :loading="isLoadingInfoPacchetto" v-model="textSimulazioniRimanenti" readonly></v-text-field>
        </v-row>
        <v-row>
          <v-text-field value="Cliccatori attivi" :suffix="cliccatoriAttivi" flat dense :loading="isLoadingInfoPacchetto" v-model="textCliccatoriAttivi" readonly></v-text-field>
        </v-row>
        <v-row>
          <v-text-field value="Squadre attive" :suffix="squadreAttive" flat dense :loading="isLoadingInfoPacchetto" v-model="textSquadreAttive" readonly></v-text-field>
        </v-row>
        <v-row>
          <v-text-field value="Sconto applicato" :suffix="scontoApplicato" flat dense :loading="isLoadingInfoPacchetto" v-model="textScontoApplicato" readonly></v-text-field>
        </v-row>
      </v-col>
      <v-col v-if="!amIProvaGratuita" data-tour-step-account="7" @click="apriDialogAcquistoRicariche()" sm="12" md="2" class="d-flex flex-column justify-center align-center" :style="`margin: 10 0; border-radius:20px; background-color:${scdOrange}; margin: 17px 0; cursor:pointer;`"> 
          <div style="color:white; font-weight:700; font-size:20px; text-align:center; margin-bottom:5px; line-height: 1.4;">
            Acquista simulazioni
          </div>
          <div :style="`border-radius:50px; background-color:${scdColor}; padding:7px;`">
            <v-icon color="white">add</v-icon>
          </div>
      </v-col>
      <v-col v-else data-tour-step-account="7" @click="apriFinestraAcquistoSimulatore()" sm="12" md="2" class="d-flex flex-column justify-center align-center" :style="`margin: 10 0; border-radius:20px; background-color:${scdOrange}; margin: 17px 0; cursor:pointer;`"> 
          <div style="color:white; font-weight:700; font-size:20px; text-align:center; margin-bottom:5px; line-height: 1.4;">
            Acquista il Simulatore
          </div>
          <div :style="`border-radius:50px; background-color:${scdColor}; padding:7px;`">
            <v-icon color="white">add</v-icon>
          </div>
      </v-col>
    </v-row>

    <ricariche-component :toggleDialog="isFinestraAcquistoRicaricheAperta" @toggle-dialog="toggleDialogAcquistoRicariche($event)"></ricariche-component>

    <!-- <v-dialog v-model="isFinestraAcquistoAperta" min-width="700" width="700">
      <v-card  class="dialog_ricariche">
        <v-card-title class="headline ml-1">
          Acquista simulazioni
          <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="isFinestraAcquistoAperta = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>

          <v-item-group 
            v-model="idPrezzoStripeSelezionato"
            mandatory
          >
            <v-container>
              <v-row class="dialog_ricariche">
                <v-col
                  v-for="ricarica in ricariche"
                  :key="ricarica.id_prezzo_stripe"
                  cols="12"
                  md="12"
                  class="pa-1"
                >
                  <v-item 
                    v-slot="{ active, toggle }"
                    :value="ricarica.id_prezzo_stripe"
                  >
                    <v-card
                      :color="active ? scdOrange : scdColor"
                      class="d-flex align-center px-4"
                      dark
                      height="50"
                      flat
                      @click="toggle"
                    >
                      <div>
                          <span style="font-size:16px;" class="_bold mr-6">{{ ricarica.numero_simulazioni }} simulazioni</span>
                          <span class="_semi_bold mr-1">{{ vatNumberValidated != 'valid' ? (ricarica.costo/1.22).toFixed(2) : ricarica.costo }} €</span>
                          <span class="_semi_bold" style="font-size:10px;">+ IVA</span>
                      </div>
                      <v-scroll-x-reverse-transition>
                        <div
                          v-if="active"
                          class="text-h2 flex-grow-1 text-right"
                        >
                          <v-icon style="font-size:25px;">mdi-cursor-default-click-outline</v-icon>
                        </div>
                      </v-scroll-x-reverse-transition>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>

        </v-card-text>
        <v-card-actions>
          <v-btn :color="scdColor" style="text-transform:none; padding:0 20px; color:white; letter-spacing:normal;" depressed rounded class="mr-4 mb-3" @click="isFinestraAcquistoAperta = false">Chiudi</v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="provaGratuita" :color="scdOrange" style="text-transform:none; padding:0 20px; color:white; letter-spacing:normal;" depressed rounded class="mr-4 mb-3" @click="vaiAlCarrello(idPrezzoStripeSelezionato)">Vai al carrello</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-snackbar v-model="showSnackbar" bottom timeout="5000" v-if="alertType != null && message != null" :color="(alertType != 'error' ? scdColor : 'error')">
      {{ message }}
      <v-btn color="white" text @click="alertType = null">
        Chiudi
      </v-btn>
    </v-snackbar>

  </v-container>
</template>


<script>
import mixin from '../mixins';
export default {
  data() {
    return {
      showSnackbar: false,

      alertType: null,
      message: null,

      ruolo: window.__RUOLO__,

      isLoadingInfo: null,
      info: null,

      bandi: [],
      bandoId: null,
      isLoadingBando: false,

			isLoadingTempiRegione: false,
      tempiPerRegione: [],

      chiPuoModificareiDatiDelCliccatore: null,
      permessiModificheDatiCliccatore: [
        { label: 'Abilitate per tutti', value: 'Cliccatore'},
        { label: 'Solo Admin e Coordinatori', value: 'Teamleader'},
        { label: 'Solo Admin', value: 'Admin'},
        { label: 'Nessuno', value: 'Nessuno'},
      ],
      isLoadingPermessiDati: false,

      tempoDaBattere: null,
      isLoadingTempoDaBattere: false,
	    isSavingTempoDaBattere: false,
	    
	    minimoSimulazioniSelezione: null,
	    isSavingMinimoWinScoreSelezione: false,
	    minimoWinScoreSelezione: null,
	    isSavingMinimoSimulazioniSelezione: false,

      textSimulazioniRimanenti: 'Simulazioni rimanenti',
      textCliccatoriAttivi: 'Cliccatori attivi',
      textSquadreAttive: 'Squadre attive',
      textScontoApplicato: 'Sconto applicato sulle ricariche',

			isLoadingInfoPacchetto: false,
      simulazioniRimanenti: null,
      cliccatoriAttivi: null,
      squadreAttive: null,
      scontoApplicato: null,
	    linkTempiBandoPrecedente: null,

      // provaGratuita: null,

      isFinestraAcquistoRicaricheAperta: false,
      // ricariche: [],
      // vatNumberValidated: null,
      // idPrezzoStripeSelezionato: null
      // intestatarioCarta: null,

      // stripeAPIToken: 'pk_test_2L51w5IWH9m1QiPiRBEaCpPY002k9A5Vnq',
      // stripe: '',
      // elements: '',
      // card: ''
    };
  },
  async created() {
		this.isLoadingBando = true;
		this.isLoadingPermessiDati = true;
		this.isLoadingInfoPacchetto = true;
		this.isLoadingTempiRegione = true;

    this.getBandi();
    await this.getAccountInfo();
		await this.getTempiRegioneByBandoId();

    // FUNZIONALITÀ ABILITATE PER L'UTENTE NUMERO 2
    // if (window.__ID_CLIENTE__ == 2) {
    //   this.distribuzioneDatiAziendeEnabled = true;
    // }
    
  },
  mounted() {
    // this.configuraStripe();
  },
  watch: {
    alertType: function(newVal){
      if(newVal != null){
        this.showSnackbar = true; // Mostra la Snackbar quando c'è un messaggio di successo/errore
      }
    },
  },
  methods: {
    getAccountInfo: function(){ // Restituisce le informazioni basilari del Cliccatore (Simulazioni Rimanenti, Tempo da battere, Squadra, ecc):
      this.alertType = null;
      this.message = null;
      
      this.isLoadingInfo = true;
			this.isLoadingTempoDaBattere = true;

      return axios.get("/account/info")
        .then(response => {
          if (response.data.hasError) {
            this.alertType = "error";
            this.message = response.data.message;
          } else {
            this.info = response.data;
            this.bandoId = response.data.bandoId;

            this.chiPuoModificareiDatiDelCliccatore = response.data.chiPuoModificareiDatiDelCliccatore;
            this.tempoDaBattere = response.data.tempoDaBattere;
						
            this.minimoSimulazioniSelezione = response.data.minimoSimulazioniSelezione;
            this.minimoWinScoreSelezione = response.data.minimoWinScoreSelezione;

            this.simulazioniRimanenti = response.data.simulazioniRimanenti;
            this.cliccatoriAttivi = `${response.data.cliccatoriAttivi} / ${response.data.maxCliccatori}`;
            this.squadreAttive = response.data.squadreAttive;
            this.scontoApplicato = `${response.data.scontoApplicato}%`;
						this.linkTempiBandoPrecedente = response.data.link_tempi_bando_precedente
          }
        })
        .catch(error => {
          this.alertType = "error";
          this.message = "Errore nel caricamento delle informazioni dell'account";
        })
        .finally(() => {
          this.isLoadingInfo = false;
          this.isLoadingBando = false;
          this.isLoadingPermessiDati = false;
          this.isLoadingTempoDaBattere = false;
          this.isLoadingInfoPacchetto = false;
        });
    },
    getBandi() {
      axios
      .get('/getBandi')
      .then(response => {
        this.bandi = response.data.bandi;
      })
    },
    getTempiRegioneByBandoId() {
			this.isLoadingTempiRegione = true;
      return axios.get(`bandi/tempiPerRegione/${this.bandoId}`)
				.then(response => {
					let tempiPerRegione = response.data.tempi_per_regione;
					this.tempiPerRegione = [];
					for (const regione in tempiPerRegione) {
						let tempo = tempiPerRegione[regione];
						this.tempiPerRegione.push({
							regione: regione,
							tempo: tempo
						});
					}
				})
				.finally(() => {
					this.isLoadingTempiRegione = false;
				});
    },
    setBando() {
      this.alertType = null;
      this.message = null;
      this.isLoadingBando = true;

      axios.patch("/setBando", { bandoId: this.bandoId })
				.then(response => {
					if (response.data.hasError) {
						this.alertType = "error";
						this.message = response.data.messages[0];
					} else {
						this.showSnackbar = true;
						this.alertType = "success";
						this.message = "Modifica avvenuta con successo.";
						
						window.__BANDO_ID__ = response.data.bando_id;
						
						this.getAccountInfo();
					}
				})
				.then(() => {
					this.getTempiRegioneByBandoId();
				})
				.catch(error => {
					this.alertType = "error";
					this.message = "Errore nella modifica del bando.";
				})
				.finally(() => {
					this.isLoadingBando = false;
				});
    },
    setPermessoModificheDati(value) {
      this.isLoadingPermessiDati = true;

      axios.patch('/setPermessoModificheDati', { chiPuoModificareiDatiDelCliccatore: value})
      .then(response => {})
      .finally(() => {
        this.isLoadingPermessiDati = false;
      });
    },
    setTempoDaBattere() {
      this.isSavingTempoDaBattere = true;
      axios.patch('/setTempoDaBattere', { tempoDaBattere: this.tempoDaBattere})
      .then(response => {})
      .finally(() => {
        this.isSavingTempoDaBattere = false;
      });
    },
	  setMinimoSimulazioniSelezione() {
      this.isSavingMinimoSimulazioniSelezione = true;
      axios.patch('/setMinimoSimulazioniSelezione', {
				minimoSimulazioniSelezione: this.minimoSimulazioniSelezione
			})
      .then(response => {})
      .finally(() => {
        this.isSavingMinimoSimulazioniSelezione = false;
      });
    },
	  setMinimoWinScoreSelezione() {
      this.isSavingMinimoWinScoreSelezione = true;
      axios.patch('/setMinimoWinScoreSelezione', {
				minimoWinScoreSelezione: this.minimoWinScoreSelezione
			})
      .then(response => {})
      .finally(() => {
        this.isSavingMinimoWinScoreSelezione = false;
      });
    },
    apriUpgradeSimulatore: function(){
      window.open("https://simulatoreclickday.it/pacchetti-di-aggiornamento/", "_blank");
    },
    apriDialogAcquistoRicariche() {
      this.isFinestraAcquistoRicaricheAperta = true;
    },
    toggleDialogAcquistoRicariche(event) {
      this.isFinestraAcquistoRicaricheAperta = event;
    },
    apriFinestraAcquistoSimulatore() {
      window.location.href = 'https://simulatoreclickday.it/acquista/';
    },
	  visualizzaTempi() {
		  console.log(this.linkTempiBandoPrecedente);
			if (this.linkTempiBandoPrecedente !== null) {
				window.open(this.linkTempiBandoPrecedente, "_blank");
			}
	  }
  }
};
</script>

<style lang="scss" scoped>
  ._pagina_account,
  ::v-deep .dialog_ricariche {
    font-family: 'Montserrat', sans-serif !important;
    font-size: 14px;
    color: #6D94CD;
    font-weight: 400;
    line-height:1.5;
    padding-top: 20px;
  }

  ._bold {
    font-weight: 700;
  }
  ._semi_bold {
    font-weight: 600;
  }

  ::v-deep .v-input__append-outer {
    margin-top: 0 !important;
  }

  .custom-space-checkboxes ::v-deep .v-input--checkbox {
    margin-right: 20px;
  }

  ::v-deep .tempi-simple-table {
    background-color:#eeeeee;
    color: #434343 !important;
    border: 2px solid #6d94cd !important;
    & thead tr th {
        // border-bottom: none !important;
        color: #eee !important;
        background-color:#6d94cd !important;
        // height: 18px;
        // font-size: 15px;     
        // &:not(:nth-child(2)) {
        //   color: #6d94cd;
        // }
        // &:nth-child(2) {
        //   color: #fff;
        //   background-color: #e6901c;
        // }
    }
  }
</style>